import React, { useState } from 'react'
import {
  StyledTab,
  SubmitFlex,
  MenuFlex,
  CalenderWrap,
} from 'modules/Drive/Partials/DrivesInfoTable/Style/style'
import FilterDivWithoutSearch from 'components/FilterDivWithoutSearch'
import Button from 'components/Button'
import CalendarPicker from 'components/CalendarPicker'
import DriveModeFilter from 'modules/Dashboard/Partials/DashboardDrive/Partials/DriveInfoTable/Partials/DriveFilter/Partials/DriveModeFilter'
import DriveStatusFilter from 'modules/Drive/Partials/DrivesInfoTable/Partials/DriveFilter/Partials/DriveStatusFilter'
import moment from 'moment'

const { TabPane } = StyledTab

const DriveFilter = ({ setQuery, setFilterQuery }) => {
  const [filters, setFilters] = useState({})
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [driveMode, setDriveMode] = useState([])
  const [driveStatus, setDriveStatus] = useState([])
  const [calendarValue, setCalendarValue] = useState([])

  const onDriveCancel = () => {
    setIsMenuOpen(false)
    setFilters({})
    setDriveMode([])
    setDriveStatus([])
    setCalendarValue([])
  }

  const onDriveModeChange = mode => {
    if (mode.length) {
      setDriveMode([mode[mode.length - 1]])
      setFilters(prev => {
        return { ...prev, driveMode: [mode[mode.length - 1]] }
      })
    } else {
      setDriveMode([])
      let filterCopy = { ...filters }
      delete filterCopy.driveMode
      setFilters(filterCopy)
    }
  }
  const onDriveStatusChange = status => {
    if (status.length) {
      setDriveStatus([status[status.length - 1]])
      setFilters(prev => {
        return { ...prev, instituteStatus: [status[status.length - 1]] }
      })
    } else {
      setDriveStatus([])
      let filterCopy = { ...filters }
      delete filterCopy.instituteStatus
      setFilters(filterCopy)
    }
  }
  const pickerChangeHandler = dates => {
    setCalendarValue(dates)
    if (dates?.length) {
      let datesString = dates.map(date =>
        moment(date?.unix * 1000).format('YYYY-MM-DD')
      )
      setFilters(prev => {
        return { ...prev, dates: datesString.toString() }
      })
    } else {
      let filtersCopy = { ...filters }
      delete filtersCopy.dates
      setFilters(filtersCopy)
    }
  }

  const submitFilter = () => {
    if (Object.keys(filters).length) {
      let queryParams = ''
      Object.keys(filters).forEach(val => {
        queryParams = `${queryParams}${val}=${filters[val]}&`
      })
      queryParams = queryParams.substring(0, queryParams.length - 1)
      setFilterQuery(queryParams)
      setQuery(queryParams)
      setIsMenuOpen(false)
    }
    setIsMenuOpen(false)
  }

  const menu = (
    <MenuFlex column>
      <StyledTab border={true} tabPosition={'left'} type="card">
        <TabPane tab="Drive Mode" key="1">
          <DriveModeFilter value={driveMode} setDriveMode={onDriveModeChange} />
        </TabPane>
        <TabPane tab="Drive Dates" key="2">
          <CalenderWrap>
            <CalendarPicker
              multiple={true}
              numberOfMonths={2}
              value={calendarValue}
              onCalenderChange={pickerChangeHandler}
            />
          </CalenderWrap>
        </TabPane>
        <TabPane tab="Drive Status" key="3">
          <DriveStatusFilter
            value={driveStatus}
            setDriveStatus={onDriveStatusChange}
          />
        </TabPane>
      </StyledTab>
      <SubmitFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            onDriveCancel()
          }}
        />
        <Button.Primary
          
          text="Apply Filter"
          onClick={() => {
            submitFilter()
          }}
        />
      </SubmitFlex>
    </MenuFlex>
  )
  return (
    <FilterDivWithoutSearch
      overlayMenu={menu}
      open={isMenuOpen}
      setOpen={flag => {
        setIsMenuOpen(flag)
      }}
    />
  )
}

export default DriveFilter
